<template>
    <div class="coupon-custom-select">
        <div class="select-box" :class="popShow ? 'show' : ''" @click.stop="handleChangePop">
            <div class="select-info" v-if="couponCard.length">
                {{ couponCard[0].coupon_name }}
                <template v-if="couponCard.length > 1">
                    ,{{ couponCard[1].coupon_name }}
                </template>
            </div>
            <div v-else>请选择电子礼券</div>
            <i class="iconfont" :style="{transform: popShow ? 'rotate(270deg)' : 'rotate(90deg)'}">&#xe636;</i>
        </div>
        <div class="secect-section" v-if="popShow" @click.stop="prevent">
            <template v-if="filterList.length">
                <VueScroll :ops="vsOpts">
                    <ul class="ul">
                        <li class="li"
                            :class="[selectedArr.includes(index) ? 'active' : '', ((item.canUse && selectedArr.length < 2) || selectedArr.includes(index)) ? '' : 'no_use']"
                            v-for="(item, index) in filterList" :key="index" @click="handleSecletItem(index)">
                            {{ item.coupon_name }}
                            <i class="iconfont select-all">{{ selectedArr.includes(index) ? '&#xe640;' : '&#xe60f;' }}</i>
                        </li>
                    </ul>
                </VueScroll>
                <div class="pop-btn">
                    <button class="c-button c-button--primary" @click="handleConfirm">确定</button>
                </div>
            </template>
            <template v-else>
                <div class="warn">暂无可用电子礼券</div>
            </template>
        </div>
    </div>
</template>

<script>
import 'vuescroll/dist/vuescroll.css';
import VueScroll from 'vuescroll/dist/vuescroll-native';
import types from "@/store/types";
import api from "@/utils/api";

export default {
    name: 'CouponSelect',
    components: { VueScroll },
    props: {
        couponList: {
            type: Array,
            required: true,
        },
        couponCard: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            vsOpts: {
                bar: {
                    background: '#F6F6F6'
                }
            },
            popShow: false,
            filterList: [],
            selectedArr: [],
        }
    },
    created() {
        // if (this.couponList.length) {
        //     this.filterList = JSON.parse(JSON.stringify(this.couponList));
        //     this.filterList.forEach(item => {
        //         item.canUse = true;
        //     })
        // }
    },
    watch: {
        'couponCard': {
            handler: function (newV) {
                let _selectedArr = [];
                if (newV.length) {
                    newV.forEach((item) => {
                        _selectedArr.push(this.couponList.findIndex(j => j.coupon_id == item.coupon_id))
                    })
                }
                this.selectedArr = _selectedArr;
            },
            deep: true,
            immediate: true
        },
        "couponList": {
            handler: function (newV) {
                if(newV.length) {
                    this.filterList = JSON.parse(JSON.stringify(newV));
                    this.filterList.forEach(item => {
                        item.canUse = true;
                    })
                } else {
                    this.filterList = []
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleChangePop() {
            this.popShow = !this.popShow;
            this.initEvent();
            if (this.selectedArr.length && this.popShow) {
                this.getRelProductRules(this.selectedArr[0])
            }
        },
        clostPop() {
            this.popShow = false;
        },
        handleSecletItem(index) {
            if (this.selectedArr.includes(index)) {
                this.selectedArr = this.selectedArr.filter(item => item !== index);
            } else {
                if (this.selectedArr.length == 2 || !this.filterList[index].canUse) {
                    return;
                }
                this.selectedArr.push(index);
            }
            if (this.selectedArr.length) {
                this.getRelProductRules(this.selectedArr[0])
            } else {
                this.filterList.forEach(item => {
                    item.canUse = true;
                })
            }
        },
        handleConfirm() {
            let _item = []
            this.selectedArr.forEach(i => {
                _item.push(this.filterList[i])
            })
            this.$emit('onConfirm', _item);
            this.popShow = false;
        },
        getRelProductRules(index) {
            let _data = {
                coupon_id: this.filterList[index].coupon_id,
                vaild_coupons: this.couponList
            }

            this.$loading({ message: '', });
            api[types.GET_REL_PRODUCTRULES](_data).then(res => {
                let { code, data } = res;
                if (code == 1) {
                    let _items = this.filterList;
                    if (data?.length) {
                        _items.forEach((i) => {
                            if (data.some(j => j.coupon_id === i.coupon_id)) {
                                i.canUse = true;
                            } else {
                                i.canUse = false;
                            }
                        })
                        this.filterList = _items;
                    } else {
                        _items.forEach((i) => {
                            i.canUse = false;
                        })
                        this.filterList = _items;
                    }
                    this.$forceUpdate()
                }
                this.$loading({ visible: false });
            }).catch(() => {
                this.$loading({ visible: false });
            })
        },
        // 外部点击事件处理
        initEvent() {
            document.addEventListener("click", this.clostPop, false);
            this.$once("hook:beforeDestroy", () => {
                document.removeEventListener("click", this.clostPop, false);
            });
        },
        prevent() {
            
        }
    }
}

</script>

<style lang="scss" scoped>
.coupon-custom-select {
    position: relative;

    .select-box {
        height: 44px;
        padding: 0 0.625rem 0 1.25rem;
        cursor: pointer;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(213, 213, 213, 1);
        border-radius: 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-grow: 1;
        width: 100%;
        
        .select-info {
            width: calc(100% - 26px);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &.show {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }
        .iconfont {
            transition: all .3s;
        }
    }

    .secect-section {
        background: #fff;
        position: absolute;
        top: 40px;
        width: 100%;
        z-index: 2;
        border: 1px solid rgba(213, 213, 213, 1);
        // border-top: unset;
        
        .warn {
            padding: 12px;
        }

        .ul {
            max-height: 300px;
            overflow-y: auto;
            .li {
                cursor: pointer;
                padding: 12px;
                font-size: 16px;
                line-height: 16px;
                color: #35495e;
                display: flex;
                justify-content: space-between;

                &:hover {
                    background: #f8f8f8;
                }

                &.active {
                    color: #333;
                    background: #f3f3f3;
                    font-weight: bold;
                }

                &.no_use {
                    opacity: .3;
                    cursor: unset;
                }
            }
        }
    }

    .pop-btn {
        display: flex;
        justify-content: flex-end;
        padding: 0 12px 12px 0;
    }
}
</style>